import LegalLayout, { LegalH2, LegalP, LegalUL } from "@/components/LegalLayout";

const PURPOSES = [
    ["Responder a tus consultas y solicitudes de información", "Tu consentimiento y la aplicación de medidas precontractuales"],
    ["Gestionar la reserva de llamadas y sesiones", "Ejecución de un contrato o medidas precontractuales"],
    ["Prestar los servicios contratados (mentorías, sesiones, formaciones)", "Ejecución del contrato"],
    ["Emitir facturas y cumplir obligaciones fiscales", "Obligación legal"],
    ["Enviarte comunicaciones, contenidos y novedades (lista de espera, newsletter, canal)", "Tu consentimiento, que puedes retirar en cualquier momento"],
    ["Medir y mejorar la web y las campañas (analítica y píxel de Meta)", "Tu consentimiento mediante el banner de cookies"],
];

export default function PoliticaPrivacidad() {
    return (
        <LegalLayout eyebrow="Legal" title="Política de Privacidad">
            <LegalH2>Responsable del tratamiento</LegalH2>
            <LegalP>
                Santiago Lorenzo Garrido — NIF 34986749T — Calle Méjico 4, 24193
                Navatejera (León), España — santilorenzo@desactivaelpatron.com.
            </LegalP>

            <LegalH2>Qué datos tratamos</LegalH2>
            <LegalUL>
                <li>
                    Datos identificativos y de contacto que nos facilitas en formularios,
                    al escribirnos por WhatsApp o email, o al reservar una llamada: nombre,
                    email, teléfono, país y la información que decidas compartir sobre tu
                    situación.
                </li>
                <li>Datos de compra, cuando adquieres un programa (gestionados por Hotmart).</li>
                <li>
                    Datos de navegación, mediante cookies, solo si las aceptas (ver
                    Política de Cookies).
                </li>
            </LegalUL>

            <LegalH2>Para qué los usamos y con qué base legal</LegalH2>
            <div className="overflow-x-auto mb-6">
                <table className="w-full border-collapse text-sm">
                    <thead>
                        <tr>
                            <th className="text-left py-3 pr-4 border-b border-gold/40 text-gold font-medium tracking-wide">
                                Finalidad
                            </th>
                            <th className="text-left py-3 pl-4 border-b border-gold/40 text-gold font-medium tracking-wide">
                                Base legal
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {PURPOSES.map(([f, b], i) => (
                            <tr key={i}>
                                <td className="py-3 pr-4 border-b border-white/10 text-zinc-200 font-light align-top">
                                    {f}
                                </td>
                                <td className="py-3 pl-4 border-b border-white/10 text-zinc-400 font-light align-top">
                                    {b}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <LegalH2>Datos sensibles</LegalH2>
            <LegalP>
                Te pedimos que no incluyas en formularios información de salud. Si durante
                una sesión compartes voluntariamente información de este tipo, se tratará
                con confidencialidad, solo para prestar el servicio y sobre la base de tu
                consentimiento explícito.
            </LegalP>

            <LegalH2>Cuánto tiempo los conservamos</LegalH2>
            <LegalP>
                Mientras dure la relación y, después, durante los plazos legales (por
                ejemplo, 6 años para documentación contable y fiscal). Los datos de
                comunicaciones comerciales, hasta que retires tu consentimiento.
            </LegalP>

            <LegalH2>Con quién los compartimos</LegalH2>
            <LegalP>
                No vendemos tus datos. Pueden acceder a ellos, como encargados del
                tratamiento, los proveedores necesarios para prestar el servicio:
            </LegalP>
            <LegalUL>
                <li>Hotmart (pagos y acceso a programas)</li>
                <li>Calendly (reserva de llamadas)</li>
                <li>Meta Platforms (WhatsApp, y el píxel de Meta si aceptas cookies)</li>
                <li>Zoom (sesiones online)</li>
                <li>MailerLite (envío de emails)</li>
                <li>Emergent y su proveedor de alojamiento (hosting de la web)</li>
                <li>Google (Search Console y, en su caso, analítica)</li>
                <li>Asesoría fiscal, para obligaciones legales</li>
            </LegalUL>
            <LegalP>
                Algunos de estos proveedores están fuera del Espacio Económico Europeo
                (principalmente EE. UU.). En esos casos, las transferencias se amparan en
                el Marco de Privacidad de Datos UE-EE. UU. o en cláusulas contractuales
                tipo aprobadas por la Comisión Europea.
            </LegalP>

            <LegalH2>Tus derechos</LegalH2>
            <LegalP>
                Puedes ejercer tus derechos de acceso, rectificación, supresión,
                oposición, limitación del tratamiento y portabilidad, y retirar tu
                consentimiento en cualquier momento, escribiendo a santilorenzo@desactivaelpatron.com
                con el asunto "Protección de datos". Si consideras que no hemos atendido
                correctamente tu solicitud, puedes presentar una reclamación ante la
                Agencia Española de Protección de Datos (www.aepd.es).
            </LegalP>

            <LegalH2>Menores</LegalH2>
            <LegalP>Los servicios están dirigidos a mayores de 18 años.</LegalP>

            <LegalH2>Seguridad</LegalH2>
            <LegalP>
                Aplicamos medidas técnicas y organizativas razonables para proteger tus
                datos frente a pérdida, uso indebido o acceso no autorizado.
            </LegalP>
        </LegalLayout>
    );
}
